var appsettings = [
    
    /* DEV */
    
   // {key: "user.scope", value: ["msauser", "msacoreapi", "notificationapi"]},   
    //{key: "glasschain.auth.host.addr", value: "http://localhost:6001"},
   // {key: "glasschain.msa.core.host.addr", value: "http://localhost:10001"},
    //{key: "glasschain.org.core.host.addr", value: "http://localhost:7001"},
   

    /* TEST */
    
     {key: "user.scope", value: ["msauser", "msacoreapi", "notificationapi"]},   
     {key: "glasschain.auth.host.addr", value: "https://gc-msa-auth-svc.azurewebsites.net"},
     {key: "glasschain.msa.core.host.addr", value: "https://gc-msa-core-test-svc.azurewebsites.net"},
     {key: "glasschain.org.core.host.addr", value: "https://gc-qa2-core-test-svc.azurewebsites.net"},
    

    /* PROD */
    
    // {key: "user.scope", value: ["msauser", "msacoreapi", "notificationapi"]},   
    // {key: "glasschain.auth.host.addr", value: "https://gc-msa-auth-svc.azurewebsites.net"},
    // {key: "glasschain.msa.core.host.addr", value: "https://gc-msa-core-svc.azurewebsites.net"},
    // {key: "glasschain.org.core.host.addr", value: "https://gc-qa2-core-svc.azurewebsites.net"},
    

    {key: "glasschain.notification.host.addr", value: "https://gc-notification-svc.azurewebsites.net"},
    {key: "glasschain.notification.direct.template.id", value: "d-2e4553f161e0408fafecab1d6d5bb750"},
    {key: "glasschain.notification.alert.template.id", value: "d-1503c1d9fbc8474db097d81fd9d8d2d6"},

    {key: "glasschain.proxy.addr", value: 
        [
            {"companyGcid": "cg", "hostaddr": "https://gc-adapter-proxy-cg.azurewebsites.net"}
        ]
    },
    {key: "glasschain.proxy.roles", value: 
        [
            {"companyGcid": "cg", "roles": ["fetchByPallet"]},
            {"companyGcid": "gcdemo", "hostaddr": "https://gc-adapter-proxy-cg.azurewebsites.net"},
            {"companyGcid": "om", "roles": ["fetchByPallet"]} //, "postHoldRequest"]}
        ]
    },
    {key: "glasschain.obs.storage.account.blob", value: "gcblobstoredurable1"},
    {key: "glasschain.image.store.addr", value: "https://gcblobstoredurable1.blob.core.windows.net"},
    {key: "glasschain.obs.image.store.addr", value: "https://gcblobstoredurable1.blob.core.windows.net/gcid"},
    {key: "version", value: "02.13.03"},

    {key: "glasschain.api.usebearertoken", value: false},
    {key: "receipt.status.poller.interval", value: 10000},
    {key: "receipt.mratag.maxlength", value: 8}



]


module.exports = {
    appsettings
}